module.exports = __webpack_public_path__ + "img/bar_on.4ab82c65.png";